import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { TextMedium16 } from "@/app/components/texts";
import { getDaysInMonth } from '@/app/utils/dateUtils';

type PanelType = 'month' | 'day' | 'year' | null;

interface DatePickerPanelProps {
  openType: PanelType;
  isWhite?: boolean;
  selected: Date;
  filteredDays: number[];
  filteredMonths: Array<{ m: string; i: number }>;
  filteredYears: number[];
  onUpdate: (date: Date) => void;
}

const DatePickerPanel: React.FC<DatePickerPanelProps> = ({
  openType,
  isWhite = false,
  selected,
  filteredDays,
  filteredMonths,
  filteredYears,
  onUpdate
}) => {
  if (!openType) return null;

  return (
    <div className={classNames(styles.panel, { [styles.white]: isWhite })}>
      <ul className={classNames(styles.list, { [styles.white]: isWhite })}>
        {openType === 'month' &&
          filteredMonths.map(({ m, i }) => (
            <li
              key={m}
              className={classNames(
                styles.listItem,
                { [styles.selected]: i === selected.getMonth() }
              )}
              onClick={() => {
                const maxDay = getDaysInMonth(i, selected.getFullYear());
                let newDay = selected.getDate();
                if (newDay > maxDay) newDay = maxDay;
                const newDate = new Date(selected);
                newDate.setMonth(i);
                newDate.setDate(newDay);
                onUpdate(newDate);
              }}
            >
              <TextMedium16 text={m} />
            </li>
          ))
        }
        {openType === 'day' &&
          filteredDays.map(d => (
            <li
              key={d}
              className={classNames(
                styles.listItem,
                { [styles.selected]: d === selected.getDate() }
              )}
              onClick={() => {
                const newDate = new Date(selected);
                newDate.setDate(d);
                onUpdate(newDate);
              }}
            >
              <TextMedium16 text={d.toString()} />
            </li>
          ))
        }
        {openType === 'year' &&
          filteredYears.map(y => (
            <li
              key={y}
              className={classNames(
                styles.listItem,
                { [styles.selected]: y === selected.getFullYear() }
              )}
              onClick={() => {
                const maxDay = getDaysInMonth(selected.getMonth(), y);
                let newDay = selected.getDate();
                if (newDay > maxDay) newDay = maxDay;
                const newDate = new Date(selected);
                newDate.setFullYear(y);
                newDate.setDate(newDay);
                onUpdate(newDate);
              }}
            >
              <TextMedium16 text={y.toString()} />
            </li>
          ))
        }
      </ul>
    </div>
  );
};

export default DatePickerPanel;